import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface NagStandardModalData {
	action: 'add' | 'edit';
	placeTypeList?: PlaceType[]; // The list of place types
	countyList?: ParentCounty[];
	standard?: {
		name: string;
		parentId?: number
	};
}
export interface NagStandardModalOutput {
	name: string;
	placeTypes: string[]; // Selected place types
	parentId?: number;
}
export interface PlaceType { name: string; selected: boolean; }
export interface ParentCounty {
	name: string;
	id: number;
}

@Component({
	selector: 'app-nag-standard-modal',
	templateUrl: './nag-standard-modal.component.html',
	styleUrls: ['./nag-standard-modal.component.css']
})
export class NagStandardModalComponent implements OnInit {

	public title: string;
	public standardName: string;
	public placeTypes: PlaceType[] = [];
	public countyList: ParentCounty[] = [];

	public parentCounty: ParentCounty;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: NagStandardModalData,
		public dialogRef: MatDialogRef<NagStandardModalComponent>
	) { }

	cancel() {
		this.dialogRef.close(null);
	}
	apply() {
		// Selected placeTypes
		const selected = this.placeTypes.filter((t) => t.selected).map((t) => t.name);
		// Close modal
		const data: NagStandardModalOutput = {
			name: this.standardName,
			placeTypes: selected,
			parentId: this.parentCounty ? this.parentCounty.id : null
		};
		this.dialogRef.close(data);
	}
	ngOnInit() {
		this.placeTypes = this.data.placeTypeList || [];
		this.countyList = this.data.countyList || [];
		switch (this.data.action) {
			case 'add':
				this.title = 'New Standard Name';
				break;
			case 'edit':
				this.title = 'Update Standard Name';
				this.standardName = this.data.standard.name;
				this.parentCounty = this.countyList.find((c) => c.id === this.data.standard.parentId);
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/a3i-setting/a3i-nag/nag-standard-modal/nag-standard-modal.component.ts